export enum PluginTypes {
  Como = 'como',
  Zerosix = 'zerosix',
  Pongo = 'pongo',
}
